'use strict';

angular.module('shiftTraderApp')
  .service('MWPHighlightService', ['storage', '$state', '$rootScope', '$injector', '$location', '$timeout',
    function MWPHighlightService(storage, $state, $rootScope, $injector, $location, $timeout) {
      var currentlyHighlighted = null;
      var currentTimeout = null;
      var resetCurrentlyHighlighted = false;

      var checkReset = function() {
        if (resetCurrentlyHighlighted) {
          currentlyHighlighted = null;
          resetCurrentlyHighlighted = false;
        }
      };


      this.highlightWorkPeriods = function(wpIds, dt, durationInMilliseconds, meta) {
        resetCurrentlyHighlighted = false;
        currentlyHighlighted = {
          workPeriodIds: wpIds,
          date: dt,
          duration: durationInMilliseconds,
          requestedAt: moment.utc(),
          meta: meta || {}
        };

        if (/manageWorkPeriods\.date/.test($state.current.name) && _.last($location.path().split('/')) === dt.format('YYYY-MM-DD')) {
          // $broadcast a message in this case
          $rootScope.$broadcast('sa:manageWorkPeriod:startHighlightWorkPeriods', currentlyHighlighted);
        } else {
          $rootScope.$broadcast('sa:manageWorkPeriod:dateChangeRequest', {
            moment: currentlyHighlighted.date
          });
          $timeout(function() {
            $rootScope.$broadcast('sa:manageWorkPeriod:startHighlightWorkPeriods', currentlyHighlighted);
          }, 500);
        }
      };

      this.getCurrentHighlight = function() {
        checkReset();
        if (currentlyHighlighted) {
          return currentlyHighlighted;
        } else {
          return null;
        }
      };

      this.pullCurrentHighlight = function() {
        console.log('pullCurrentHighlight called');
        checkReset();
        if (currentlyHighlighted) {
          resetCurrentlyHighlighted = true;
          return currentlyHighlighted;
        } else {
          return null;
        }
      };
    }]);
